var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5804 12.8797C12.3972 12.959 12.1997 13 12 13C11.8003 13 11.6027 12.959 11.4196 12.8797L4.38015 9.62815C4.26583 9.57065 4.16977 9.48263 4.10266 9.37391C4.03554 9.26518 4 9.14 4 9.01232C4 8.88464 4.03554 8.75946 4.10266 8.65073C4.16977 8.542 4.26583 8.45399 4.38015 8.39648L11.4196 5.12026C11.6027 5.04093 11.8003 5 12 5C12.1997 5 12.3972 5.04093 12.5804 5.12026L19.6198 8.37186C19.7342 8.42935 19.8302 8.51737 19.8973 8.6261C19.9645 8.73483 20 8.86001 20 8.98769C20 9.11536 19.9645 9.24054 19.8973 9.34927C19.8302 9.458 19.7342 9.54602 19.6198 9.60352L12.5804 12.8797Z",
    stroke: "#06315D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13L12.5108 16.4807C12.3504 16.5421 12.1763 16.5739 12 16.5739C11.8238 16.5739 11.6496 16.5421 11.4893 16.4807L4 13",
    stroke: "#06315D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17L12.5108 20.1009C12.3504 20.1623 12.1763 20.1941 12 20.1941C11.8238 20.1941 11.6496 20.1623 11.4893 20.1009L4 17",
    stroke: "#06315D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.e00d5dcdd927b44111597c8b0a9288f7.svg";
export { ForwardRef as ReactComponent };